import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { UserModel } from 'app/_models/user-model';
import { CommonservicesService } from 'app/_services/commonservices.service';
import { CrudSubcategoryService } from 'app/_services/MasterCrudOps/crud-subcategory.service';
import { NotificationService } from 'app/_services/notification.service';
import { SpreadsheetValidateService } from 'app/_services/spreadsheetValidation.service';
import { SpreadsheetFileHandler } from 'app/core/handlers/spreadsheet-file-handler';
@Component({
  selector: 'app-bulk-create-sub-category',
  templateUrl: './bulk-create-sub-category.component.html',
  styleUrls: ['./bulk-create-sub-category.component.css'],
  providers: [DatePipe],
})
export class BulkCreateSubCategoryComponent extends SpreadsheetFileHandler{
  currentUser: UserModel;
  isLoaderResult:boolean = false;
  file: File;
  uploadFileName: string;
  uploadFileContent: string;
  isAdminGroupUser: boolean = false;

  constructor(
    protected readonly datePipe: DatePipe,
    protected readonly spreadsheetService:SpreadsheetValidateService,
    protected readonly notify: NotificationService,
    private readonly crudSubCatService:CrudSubcategoryService,
    private readonly commonService:CommonservicesService
  )
  {
    super(spreadsheetService, datePipe, notify);
    this.currentUser = JSON.parse(sessionStorage.getItem("user"));
    this.isAdminGroupUser = this.currentUser.isAdminGroupUser;
  }


  downLoadFile()
  {
     this.downloadFileHelper(this.crudSubCatService.getSampleCatSubcatFile(),"SampleCatSubcat");
  }

 async uploadedFile(event: any) {
    this.handleFileUpload(
      event,
      (file) => this.uploadToAPI(file),
      "upload_bulkSubCat"
    );
  }

  
  uploadToAPI(file: File): void {
    this.uploadFileHelper(
      (formData) =>
        this.crudSubCatService.uploadFileToBulkCreateCatSubcat(formData),
      file,
      (fileName) => this.downloadResultFile(fileName)
    );
  }

 downloadResultFile(fileName: string): void{
this.downloadResultFileHelper(
      this.commonService.getResultFileByFileName(fileName),
      fileName,
      "Bulk subcategory result file download process started.",
      "Error in downloading the bulk subcategroies result file."
    );

 }

}
